import { useContext } from 'react';
import useQueryParams from 'new/hooks/useQueryParams';
import { ResourceEditContext } from 'js/components/ResourceEditProvider/ResourceEditContext';

export default function useFlowQueryParams() {
  const context = useContext(ResourceEditContext);
  const params = useQueryParams();

  return context?.queryParams || params;
}
